import Avvir from "avvir";
import { AvvirAsyncThunk } from "../make_eventful_action";
import getTosAcceptances from "../../services/getters/get_tos_acceptances";
import tosAcceptancesLoaded, { TOS_ACCEPTANCES_LOADED } from "../../events/loaded/tos_acceptances_loaded";
import { Action } from "redux";

type DispatchedEvents = Action<typeof TOS_ACCEPTANCES_LOADED>;

const loadTosAcceptances = (): AvvirAsyncThunk<typeof getTosAcceptances, DispatchedEvents> => {
  return (dispatch, getState) => {
    const user = getState().user;
    return Avvir.api.tos.getAcceptances(user).then((tosAcceptances) => {
      dispatch(tosAcceptancesLoaded(tosAcceptances));
      return getTosAcceptances(getState(), {});
    });
  };
};

export default loadTosAcceptances;
